module.exports = __webpack_public_path__ + "img/3PNG_Cover.a035c124.jpg";